import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../../../admin_resources/css/admin_layout.css";
import "../../../admin_resources/css/admin_common.css";
import "../../../admin_resources/css/admin_style.css";
import ADMIN_HEADER from "../Admin_Header";
import axios from "axios";

const Admin_Frview = () => {
  const { idx } = useParams();
  const [applyItem, setApplyItem] = useState(null);
  const [, setApplyList] = useState([]);
  const navigate = useNavigate();
  
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 관리자 페이지`;

    const fetchApply = async () => {
      try {
        const response = await axios.get("/Formlist");
        const applys = response.data;
        const selectApply = applys.find(
          (social) => social.idx === parseInt(idx)
        );
        setApplyItem(selectApply);
      } catch (error) {
        console.error("Error fetching applys:", error);
      }
    };

    fetchApply();

	  // 관리자 권한 정보 가져오기
	  const adminId = localStorage.getItem("adminId");
	  if (adminId) {
	    fetchPermissions(adminId);
	  }
	}, [idx]);

	const fetchPermissions = async (adminId) => {
	  try {
	    const response = await fetch(`/permissions/${adminId}`); // 권한 확인 API 호출
	    const data = await response.json();
	    setPermissions(data); // 권한 정보를 상태로 설정
	  } catch (error) {
	    console.error("권한 정보를 가져오는 데 실패했습니다.", error);
	  }
	};

  // 삭제 요청을 처리하는 함수
  const handleDelete = async () => {
    // 사용자가 정말로 삭제할 것인지 확인하는 창
    if (window.confirm("삭제하시겠습니까?")) {
      try {
        const response = await axios.delete(`/form_delete/${applyItem.idx}`);
        if (response.status === 200) {
          alert("삭제되었습니다.");

          // 삭제 후 배너 목록을 갱신
          setApplyList((prevList) =>
            prevList.filter((social) => social.idx !== applyItem.idx)
          );

          // 삭제 후 목록 페이지로 이동
          navigate("/admin/form/fr");
        }
      } catch (error) {
        console.error("삭제 실패:", error);
        alert("삭제에 실패했습니다.");
      }
    }
  };

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit", // 시간
      minute: "2-digit", // 분
      second: "2-digit", // 초
      hour12: false, // 24시간 형식
    };
    const date = new Date(dateString);
    return date.toLocaleString("ko-KR", options).replace(",", "");
  };

  if (!applyItem) {
    return <div>로딩 중...</div>;
  }

  const handleUpdate = async () => {
    // 수정 확인 알림창
    const isConfirmed = window.confirm("수정하시겠습니까?");

    if (!isConfirmed) {
      return; // 사용자가 취소를 선택하면 폼 제출을 중단
    }

    const formData = new FormData();
    formData.append("procId", localStorage.getItem("adminId"));
    formData.append("procName", localStorage.getItem("adminName"));
    formData.append("name", applyItem.name);
    formData.append("subGubun", applyItem.subGubun);
    formData.append("cell", applyItem.cell);
    formData.append("content", applyItem.content);
    formData.append("etc", applyItem.etc);

    try {
      const response = await axios.put(
        `/form_update/${applyItem.idx}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.status === 200) {
        alert("수정되었습니다.");
        window.location.href = "/admin/form/fr";
      }
    } catch (error) {
      console.error("수정 실패:", error);
      alert("수정에 실패했습니다.");
    }
  };

  return (
    <div>
      <ADMIN_HEADER />
      <div className="admin_view">
        <div className="path-sec">
          HOME &gt; <span className="menu1">데이터 관리</span> &gt;
          <span className="menu2"> 창업신청 관리</span>
        </div>
        <table>
          <tr>
            <td>
              <div className="sec-snb">
                <h3 className="snb_tit">데이터 관리</h3>
                <ul className="snb_list">
				{permissions.ent && (
				  <li>
				    <a href="/admin/form/ent">입회신청 관리</a>
				  </li>
				)}
				{permissions.fr && (
				  <li className="cur">
				    <a href="/admin/form/fr">창업신청 관리</a>
				  </li>
				)}
				{permissions.franchise && (
				  <li>
				    <a href="/admin/form/franchise">가맹점 관리</a>
				  </li>
				)}
				{permissions.schedule && (
				  <li>
				    <a href="/admin/form/schedule">창업일정 관리</a>
				  </li>
				)}
				{permissions.jisa && (
				  <li>
				    <a href="/admin/form/jisa">지사장 지원 관리</a>
				  </li>
				)}
				{permissions.q && (
				  <li>
				    <a href="/admin/form/q">앱 문의 관리</a>
				  </li>
				)}
				{permissions.etc_q && (
				  <li>
				    <a href="/admin/form/etc_q">기타문의 관리</a>
				  </li>
				)}
                  {(localStorage.getItem("adminId") === "jiwoo" ||
                    localStorage.getItem("adminId") === "nixona" ||
                    localStorage.getItem("adminId") === "wjdrnr90" ||
                    localStorage.getItem("adminId") === "hyoseon.jang") && (
                    <li>
                      <a href="/admin/form/point">적립금 정산 관리</a>
                    </li>
                  )}
                </ul>
              </div>
            </td>
            <td>
              <div className="bx-top">창업신청 확인</div>
              <form id="editform">
                <div className="tb_01 wr">
                  <table>
                    <tbody>
                      <tr>
                        <th>이름</th>
                        <td>
                          <input
                            name="name"
                            value={applyItem.name}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                name: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>소셜 형태</th>
                        <td>
                          <label>
                            <input
                              type="radio"
                              value="A"
                              name="subGubun"
                              checked={applyItem.subGubun === "A"}
                              onChange={() =>
                                setApplyItem({
                                  ...applyItem,
                                  subGubun: "A",
                                })
                              }
                            />
                            공부방형
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="B"
                              name="subGubun"
                              checked={applyItem.subGubun === "B"}
                              onChange={() =>
                                setApplyItem({
                                  ...applyItem,
                                  subGubun: "B",
                                })
                              }
                            />
                            단독형
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="U"
                              name="subGubun"
                              checked={applyItem.subGubun === "U"}
                              onChange={() =>
                                setApplyItem({
                                  ...applyItem,
                                  subGubun: "U",
                                })
                              }
                            />
                            샵인샵형
                          </label>
                        </td>
                      </tr>
                      <tr>
                        <th>주소</th>
                        <td>
                          <input
                            name="addr1"
                            value={applyItem.addr1}
                            type="text"
                            readOnly
                            style={{ width: "40%" }}
                          />
                          <input
                            name="addr2"
                            value={applyItem.addr2}
                            type="text"
                            readOnly
                            style={{ width: "40%", marginLeft: "10px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>연락처</th>
                        <td>
                          <input
                            name="cell"
                            value={applyItem.cell}
                            type="text"
                            maxLength="11"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                cell: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>

                      <tr>
                        <th>유입경로</th>
                        <td>
                          <input
                            name="asobiRoot"
                            value={applyItem.asobiRoot}
                            type="text"
                            readOnly
                            style={{ width: "40%" }}
                          />
                          <input
                            name="asobiRootEtc"
                            value={applyItem.asobiRootEtc}
                            type="text"
                            readOnly
                            style={{ width: "40%", marginLeft: "10px" }}
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>문의사항</th>
                        <td>
                          <input
                            name="content"
                            value={applyItem.content}
                            type="text"
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                content: e.target.value,
                              })
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>신청일[IP]</th>
                        <td>
                          {formatDate(applyItem.regDate)} [{applyItem.regIp}]
                        </td>
                      </tr>
                      <tr>
                        <th>진행상황</th>
                        <td>
                          <select
                            name="etc"
                            id="selectetc"
                            value={applyItem.etc}
                            onChange={(e) =>
                              setApplyItem({
                                ...applyItem,
                                etc: e.target.value, // select에서 선택된 값으로 applyItem 상태 업데이트
                              })
                            }
                          >
                            <option value="대기중">대기중</option>
                            <option value="전달완료">전달완료</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
              <div className="view-btn">
                <span className="btn custom_s">
                  <button>
                    <Link to="/admin/form/fr" style={{ color: "#fff" }}>
                      목록
                    </Link>
                  </button>
                </span>

                <div className="btn-right">
                  <span className="btn custom_r">
                    <button onClick={handleUpdate}>수정</button>
                  </span>
                  <span className="btn custom_d">
                    <button onClick={handleDelete}>삭제</button>
                  </span>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default Admin_Frview;
